<div class="row">
  <div
    class="col item-image"
    [ngClass]="[
      is_detail ? 'col-12 col-sm-4 col-md-3 d-flex justify-content-center' : 'col-4',
      !is_offcanvas ? 'bg-white' : ''
    ]"
  >
    <ng-container *ngIf="getImageMetaData(asset) as img">
      <img
        *ngIf="img.src"
        [ngClass]="{
          'carrier-logo':
            is_offcanvas &&
            asset?.line &&
            [multi_sim_types[1], multi_sim_types[5], multi_sim_types[6]].includes(
              offcanvas_type ?? ''
            )
        }"
        [src]="img.src"
        [attr.alt]="img.alt"
        (error)="imageLoadError($event, asset)"
      />
    </ng-container>
  </div>
  <div
    *ngIf="!is_offcanvas; else offCanvasContent"
    [ngClass]="['col asset-card__details', is_detail ? 'col-12 col-sm-8 col-md-9' : 'col-8']"
  >
    <ng-container *ngIf="hasLine(asset)">
      <div [ngClass]="['row', is_detail ? 'text-center text-sm-start ms-sm-2' : '']">
        <div
          *ngIf="asset.line.carrier_image_url"
          [class]="is_detail ? 'col-12 col-sm-4 text-center text-sm-start' : 'col-4'"
        >
          <img
            class="carrier-logo"
            [src]="asset.line.carrier_image_url"
            [alt]="asset.line.carrier_name"
          />
        </div>
      </div>
      <div
        *ngIf="asset.line.carrier_name"
        [ngClass]="['row mt-1', is_detail ? 'text-center text-sm-start ms-sm-2' : '']"
      >
        <div class="col lh-1">
          <small class="text-secondary">
            {{ asset.line.carrier_name }}
          </small>
        </div>
      </div>
      <div
        *ngIf="asset.line.international_number"
        [ngClass]="['row mt-2', is_detail ? 'text-center text-sm-start ms-sm-2' : '']"
      >
        <div class="col d-inline-flex lh-1">
          <span class="fw-normal">{{ asset.line.international_number }}</span>
          <span
            *ngIf="asset.line.asset_primary_line && asset.multi_sim_type === multi_sim_types[0]"
            class="material-icons text-info ms-1"
          >
            verified
          </span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="hasDevice(asset) || hasRefDevice(asset)">
      <div
        [ngClass]="{
          row: true,
          'mt-2': hasLine(asset),
          'text-center text-sm-start ms-sm-2': is_detail
        }"
      >
        <div class="col d-inline-flex lh-1">
          <span class="fw-normal">{{ assetName(asset) }}</span>
          <span
            *ngIf="
              asset.device.asset_primary_device &&
              [multi_sim_types[1], multi_sim_types[6]].includes(asset.multi_sim_type)
            "
            class="material-icons text-info ms-1"
          >
            verified
          </span>
        </div>
      </div>
      <div [ngClass]="['row mt-1', is_detail ? 'text-center text-sm-start ms-sm-2' : '']">
        <div class="col lh-1">
          <small class="text-secondary">
            <span *ngIf="asset.device.size"> {{ asset.device.size }} - </span>
            <span *ngIf="asset.device.color">
              {{ asset.device.color }}
            </span>
          </small>
        </div>
      </div>
    </ng-container>
    <div
      *ngIf="hasLine(asset)"
      [ngClass]="['row mt-2 me-1 status', is_detail ? 'text-center text-sm-start ms-sm-2' : '']"
    >
      <div
        [ngClass]="{
          'col d-flex gap-2 flex-wrap': true,
          'justify-content-center justify-content-sm-start': is_detail
        }"
      >
        <!-- Status -->
        <ts-status-badge
          *ngIf="asset.line.status"
          [status]="asset.line.status"
          [status_display_name]="asset.line.status_display_name"
        />

        <!-- upgrade eligibility -->
        <ts-eligibility-badge [line]="asset.line" />
      </div>
    </div>
    <ng-container *ngIf="is_detail">
      <hr class="mb-0 opacity-100 border-top" />
      <div class="row row-cols-1 row-cols-sm-2 ms-sm-2">
        <div class="col mt-3 d-flex flex-column">
          <span class="fw-normal">{{ 'plan' | translate }}</span>
          <span>{{ fieldExists(plan?.name) }}</span>
        </div>
        <div class="col mt-3 d-flex flex-column">
          <span class="fw-normal">{{ 'add_on_features' | translate }}</span>
          <span *ngIf="!plan?.features?.length; else planFeatures">
            {{ 'n_a' | translate }}
          </span>
          <ng-template #planFeatures>
            <span *ngFor="let feature of plan?.features">
              {{ feature.name }}
            </span>
          </ng-template>
        </div>
        <div class="col mt-3 d-flex flex-column">
          <span class="fw-normal">{{ 'sim_number_label' | translate }}</span>
          <span>{{ fieldExists(hasLine(asset) ? asset.line.sim_number : undefined) }}</span>
        </div>
        <div class="col mt-3 d-flex flex-column">
          <span class="fw-normal">{{ 'imei' | translate }}</span>
          <span>{{ fieldExists(hasDevice(asset) ? asset.device.imei : undefined) }}</span>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-template #offCanvasContent>
    <div
      [ngClass]="[
        'col accordion-flush offcanvas-details-accordions',
        is_detail ? 'col-12 col-sm-8 col-md-9' : 'col-8',
        is_offcanvas ? 'ps-0' : ''
      ]"
    >
      <div
        *ngIf="
          offcanvas_type &&
          [multi_sim_types[0], multi_sim_types[2], multi_sim_types[3]].includes(offcanvas_type)
        "
        class="row row-cols-2 gy-3 mb-3"
      >
        <div class="col">
          <label for="imei" class="fw-normal">{{ 'imei' | translate }}:</label>
          <span name="imei">
            {{ fieldExists(asset.device.imei) }}
          </span>
        </div>
        <div class="col">
          <label for="imei2" class="fw-normal">{{ 'imei2' | translate }}:</label>
          <span name="imei2">
            {{ fieldExists(asset.device.imei2) }}
          </span>
        </div>
        <div class="col">
          <label for="serial_number" class="fw-normal">{{ 'serial_number' | translate }}:</label>
          <span name="serial_number">
            {{ fieldExists(asset.device.serial_number) }}
          </span>
        </div>
      </div>
      <div ngbAccordion #accordion="ngbAccordion" [closeOthers]="true">
        <div
          *ngIf="
            offcanvas_type &&
            [
              multi_sim_types[1],
              multi_sim_types[4],
              multi_sim_types[5],
              multi_sim_types[6]
            ].includes(offcanvas_type)
          "
          ngbAccordionItem="service"
          [collapsed]="false"
          class="border rounded"
        >
          <h6 ngbAccordionHeader>
            <button ngbAccordionButton class="focus-visible focus-visible-inset rounded-top">
              {{ 'service_details' | translate }}
            </button>
          </h6>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="row row-cols-2 flex-wrap g-3">
                  <div class="col d-flex flex-column">
                    <span class="fw-normal">{{ 'carrier' | translate }}:</span>
                    <span>{{ fieldExists(asset?.line?.carrier_name) }}</span>
                  </div>
                  <div class="col d-flex flex-column">
                    <span class="fw-normal">{{ 'plan' | translate }}:</span>
                    <span>{{ fieldExists(asset?.line?.plan?.name) }}</span>
                  </div>
                  <div class="col d-flex flex-column">
                    <span class="fw-normal">{{ 'add_on_features' | translate }}:</span>
                    <span *ngIf="!asset.line.plan?.features?.length; else planFeatures">
                      {{ 'n_a' | translate }}
                    </span>
                    <ng-template #planFeatures>
                      <span *ngFor="let feature of asset.line.plan.features">
                        {{ feature.name }}
                      </span>
                    </ng-template>
                  </div>
                </div>
                <div class="row mt-3"></div>
              </ng-template>
            </div>
          </div>
        </div>
        <div
          *ngIf="
            offcanvas_type &&
            [multi_sim_types[0], multi_sim_types[2], multi_sim_types[3]].includes(offcanvas_type)
          "
          ngbAccordionItem="tech_specs"
          [collapsed]="true"
          class="border rounded"
        >
          <h6 ngbAccordionHeader>
            <button ngbAccordionButton class="focus-visible focus-visible-inset rounded-top">
              <span>
                {{ 'tech_specs' | translate }}
              </span>
            </button>
          </h6>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="row">
                  <div class="col d-flex flex-column">
                    <span class="fw-normal">{{ 'description' | translate }}:</span>
                    <span>{{ fieldExists(asset.device.tech_specs.description) }}</span>
                  </div>
                  <div class="col d-flex flex-column">
                    <span class="fw-normal">{{ 'sim_compatibility' | translate }}:</span>
                    <span>
                      {{ fieldExists(asset.device.tech_specs.sim_compatibility) }}
                    </span>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col d-flex flex-column">
                    <span class="fw-normal">{{ 'battery' | translate }}:</span>
                    <span>{{ fieldExists(asset.device.tech_specs.battery) }}</span>
                  </div>
                  <div class="col d-flex flex-column">
                    <span class="fw-normal">{{ 'weight' | translate }}:</span>
                    <span>{{ fieldExists(asset.device.tech_specs.weight) }}</span>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
